import React, { useState } from "react";
import OutlineTextInput from "../input/OutlineTextInput";
import { useDispatch, useSelector } from "react-redux";
import styles from "./Debitcard.module.scss";
import Button from "../button/Button";
import { apiClient } from "../../hooks/apiClient";
import {
  openLoader,
  closeLoader,
} from "../../redux/actions/loader/loaderActions";
import { openToastAndSetContent } from "../../redux/actions/toast/toastActions";
import { ToastErrorStyles } from "../../constants/toastStyles";
import { ReactComponent as VisaCardIcon } from "../../assets/images/card-brand-logos/visa.svg";
import { ReactComponent as MasterCardIcon } from "../../assets/images/card-brand-logos/mastercard.svg";
import { ReactComponent as VerveCardIcon } from "../../assets/images/card-brand-logos/verve.svg";
import { ReactComponent as AmexCardIcon } from "../../assets/images/card-brand-logos/amexlogo.svg";
import { ReactComponent as SuccessIcon } from "../../assets/images/check-circle.svg";
import { usePaymentInputs } from "react-payment-inputs";
import encryptForge from "../../utils/encryptForge";
import { commarize } from "../../utils/helpers";
import { Post } from "../../api/client";
import PrimaryTextInput from "../input/PrimaryTextInput";
import Label from "../Label/Label";
import { creditCardType } from "../../utils/cardType";
import { handleCardDisplay } from "../../utils/cardDisplay";
import {
  CheckBoxOutlineBlankRounded,
  VisibilityOffOutlined,
  VisibilityOutlined,
} from "@material-ui/icons";
import { CheckBoxOutlineBlankSharp, ContentCopy } from "@mui/icons-material";
import {
  TrackOrderStatusAction,
  authorizePayOrderAction,
  payOrderAction,
} from "../../redux/actions/orderStatus/orderStatusAction";
import PendingPaymentCard from "../PendingPaymentCard/PendingPaymentCard";
import SuccessfulPaymentCard from "../SuccessfulPaymentCard/SuccessfulPaymentCard";
import transactpay from "../../assets/images/iconlogo.png";
import CopyToClipboard from "react-copy-to-clipboard";
import { getEnvironment } from "../../utils/getEnvironment";

// get env
// const environment = getEnvironment();
// const isSandbox = environment === "DEV";

// Sandbox test cards per scenario
const SANDBOX_CARDS = {
  success: {
    CardNumber: "5123 4500 0000 0008",
    expiryDate: "01/29",
    Cvv: "100",
    pin: "",
  },
  bankAuthentication: {
    CardNumber: "5123 4500 0000 0008",
    expiryDate: "01/29",
    Cvv: "100",
    pin: "",
  },
  failed: {
    CardNumber: "5100 4500 0000 0008",
    expiryDate: "01/30",
    Cvv: "320",
    pin: "",
  },
};

type SandboxMode = "success" | "bankAuthentication" | "failed";

type DebitCardProps = {
  reference: string;
  currency: string;
  amount: number;
  saveCards: any[];
  isTestMode?: boolean;
};

const DebitCard = ({
  reference,
  amount,
  currency,
  saveCards,
  isTestMode,
}: DebitCardProps) => {
  interface initTypes {
    CardNumber: string;
    MonthAndYear: string;
    Cvv: string;
    expiryDate: string;
    pin: string;
    saveCard: string;
    savedCardId?: number;
  }

  const initProps: initTypes = {
    CardNumber: "",
    MonthAndYear: "",
    Cvv: "",
    expiryDate: "",
    pin: "",
    saveCard: "false",
  };

  const dispatch = useDispatch();
  const orderfee = useSelector((state) => state.orderFeeReducer);
  const fee: number = orderfee?.data?.customerFee ?? 0;
  const isSandbox = isTestMode;

  const { orderDetails } = useSelector((state) => state.orderDetailsReducer);
  const merchantEmail =
    orderDetails?.data?.subsidiary?.email ??
    orderDetails?.data?.customer?.email;

  const [amountCopied, setamountCopied] = useState(false);
  if (amountCopied) {
    setTimeout(() => {
      setamountCopied(false);
    }, 2000);
  }

  const [sandboxMode, setSandboxMode] = useState<SandboxMode>("success");
  const [inputs, setInputs] = React.useState<initTypes>(
    isSandbox ? { ...initProps, ...SANDBOX_CARDS.success } : initProps,
  );
  const [otpInputs, setOtpInputs] = React.useState({
    orderPaymentReference: "",
    otp: "",
    message: "",
  });
  const [useSavedCards, setUseSavedCards] = React.useState(false);
  const [paymentUrl, setPaymentUrl] = React.useState("");
  const [activeSection, setActiveSection] = React.useState(
    "collect-card-details",
  );
  const [isProcessing, setIsProcessing] = useState(false);
  const [showCvv, setShowCvv] = useState(false);

  let myWindow: any;

  function openWin(redirectUrl: string) {
    myWindow = window.open(redirectUrl, "_blank");
    if (myWindow) {
      myWindow.focus();
    } else {
      dispatch(
        openToastAndSetContent({
          toastStyles: ToastErrorStyles,
          toastContent:
            "The redirect to the payment page was blocked by your browser, please enable the redirect to complete payment",
        }),
      );
    }
  }

  const payload: any = {
    reference: reference,
    paymentOption: "C",
    card: {
      cardNumber: inputs.CardNumber.replaceAll(" ", ""),
      cvv: inputs.Cvv,
      pin: inputs.pin,
      expiryMonth: inputs.expiryDate?.substring(0, 2),
      expiryYear: inputs.expiryDate?.slice(-2),
      saveCard: inputs.saveCard == "true",
      savedCardId: null,
      authOption:
        sessionStorage.getItem("checkout_auth_option") == "c1"
          ? "NOAUTH"
          : null,
    },
    sandboxMetadata: isSandbox
      ? {
          cardMetadata: {
            status: sandboxMode,
          },
          // bankTransferMetadata: {
          //   status: "",
          // },
          // trustMetadata: {
          //   status: "",
          // },
        }
      : undefined,
  };

  const continuePayment = () => {
    setActiveSection("confirm-payment");
    if (paymentUrl) openWin(paymentUrl);
    TrackOrderStatusAction(
      payload,
      "",
      dispatch,
      (cbdata: any) => {
        if (cbdata?.status == "completed") {
          setActiveSection("successful");
        } else {
          setActiveSection("confirm-payment-pending");
        }
      },
      myWindow,
    );
  };

  const payOrderHandler = async (payload: any, isOtp = false) => {
    try {
      // console.log(payload);
      const paymentAction = isOtp ? authorizePayOrderAction : payOrderAction;

      paymentAction(payload, "bank", dispatch, (data: any) => {
        const status = data?.data?.orderPayment?.orderPaymentResponseCode;
        const redirect_url = data?.data?.paymentDetail?.redirectUrl;
        const orderpaymentReference =
          data?.data?.orderPayment?.orderPaymentReference;
        const message = data?.data?.orderPayment?.orderPaymentResponseMessage;

        if (status == "09") {
          setActiveSection("validate-otp");
          setOtpInputs({
            ...otpInputs,
            orderPaymentReference: orderpaymentReference,
            message,
          });
        } else {
          if (!isOtp) setActiveSection("confirm-redirect");
          if (status != "00" && redirect_url && !isOtp)
            setPaymentUrl(redirect_url);
          if (
            status == "00"
            // && message.toLowerCase() == "transaction was completed successfully" (out due to discrep...)
          ) {
            setActiveSection("successful");
            TrackOrderStatusAction(
              payload,
              "",
              dispatch,
              (cbdata: any) => {
                if (cbdata?.status == "completed") {
                  setActiveSection("successful");
                } else {
                  setActiveSection("confirm-payment-pending");
                }
              },
              myWindow,
            );
          }
        }
      });
    } catch (error: any) {
      dispatch(closeLoader());
      const message =
        error?.response?.data?.Message || error?.response?.data?.message;
      dispatch(
        openToastAndSetContent({
          toastStyles: ToastErrorStyles,
          toastContent: message,
        }),
      );
    }
  };

  const debitCardTransaction = async (isOtp = false) => {
    try {
      sessionStorage.setItem("checkout-payment-completed", "false");
      payOrderHandler(isOtp ? otpInputs : payload, isOtp);
    } catch (error: any) {
      dispatch(closeLoader());
      const message =
        error?.response?.data?.Message || error?.response?.data?.message;
      dispatch(
        openToastAndSetContent({
          toastStyles: ToastErrorStyles,
          toastContent: message,
        }),
      );
    }
  };

  const handleSubmit = () => {
    // console.log(" payload:", payload);
    if (paymentUrl) return continuePayment();
    dispatch(openLoader("", "default"));
    debitCardTransaction();
  };

  const handleOtpSubmit = () => {
    continuePayment();
    dispatch(openLoader("", "bank"));
    debitCardTransaction(true);
  };

  const SubmitSavedCard = (savedCardId: number) => {
    if (isProcessing) return;
    setIsProcessing(true);
    dispatch(openLoader("", "bank"));
    payload.card.savedCardId = savedCardId;
    debitCardTransaction();
  };

  const disabledFunction = () => {
    if (!inputs.CardNumber || !inputs.expiryDate || !inputs.Cvv) return true;
  };

  const [cardOtp, setCardOtp] = useState("");

  const handleCardOtpChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
  ) => {
    const value = e.target.value.replace(/[^0-9]/g, "");

    if (value.length > 1) {
      const trimmed = value.slice(0, 6);
      setCardOtp(trimmed);
      setOtpInputs((prev) => ({ ...prev, otp: trimmed }));
      const inputs =
        document.querySelectorAll<HTMLInputElement>(".cardOtpInput");
      inputs[Math.min(trimmed.length - 1, 5)]?.focus();
      return;
    }

    const newOtp = cardOtp.split("");
    newOtp[index] = value || "";
    const updated = newOtp.join("");
    setCardOtp(updated);
    setOtpInputs((prev) => ({ ...prev, otp: updated }));
  };

  const handleCardOtpKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number,
  ) => {
    if (e.key === "Backspace") {
      const newOtp = cardOtp.split("");
      if (newOtp[index]) {
        newOtp[index] = "";
        setCardOtp(newOtp.join(""));
        setOtpInputs((prev) => ({ ...prev, otp: newOtp.join("") }));
      } else {
        const prev = e.currentTarget.previousElementSibling as HTMLInputElement;
        if (prev) {
          prev.focus();
          newOtp[index - 1] = "";
          const updated = newOtp.join("");
          setCardOtp(updated);
          setOtpInputs((prev) => ({ ...prev, otp: updated }));
        }
      }
    }
  };

  const updateOtpProps = (event: React.ChangeEvent<HTMLInputElement>) => {
    let newValue = event.target.value;
    const inputName = event.target.name;
    setOtpInputs({ ...otpInputs, [inputName]: newValue });
  };

  const updateProps = (event: React.ChangeEvent<HTMLInputElement>) => {
    // Block edits to prefilled sandbox fields
    if (isSandbox) return;

    let newValue = event.target.value;
    const inputName = event.target.name;
    if (inputName == "expiryDate") {
      if (newValue.length == 2 && inputs.expiryDate.length < newValue.length) {
        newValue += "/";
      } else if (newValue.length >= 5) {
        const cvvinput = document.getElementById("cvv");
        if (cvvinput) cvvinput.focus();
      }
    }
    if (inputName == "CardNumber") {
      if (newValue.length >= 16) {
        const expiryinput = document.getElementById("inputexpiry");
        if (expiryinput) expiryinput.focus();
      }
    }
    if (inputName == "saveCard") {
      newValue = inputs.saveCard == "false" ? "true" : "false";
    }

    setInputs((prevState: initTypes) => ({
      ...prevState,
      [inputName]: newValue,
    }));
  };

  // When sandbox mode changes, swap the prefilled card details
  const handleSandboxModeChange = (mode: SandboxMode) => {
    setSandboxMode(mode);
    if (isSandbox) {
      setInputs((prev) => ({ ...prev, ...SANDBOX_CARDS[mode] }));
    }
  };

  const getCardTypeImage = (cardumber: string, cardtype?: string) => {
    if (!cardtype) cardtype = creditCardType(cardumber);
    switch (cardtype) {
      case "MASTERCARD":
        return (
          <MasterCardIcon
            style={{ height: "50px", width: "50px", objectFit: "contain" }}
          />
        );
      case "VISA":
        return (
          <VisaCardIcon
            style={{ height: "50px", width: "50px", objectFit: "contain" }}
          />
        );
      case "VERVE":
        return (
          <VerveCardIcon
            style={{ height: "50px", width: "50px", objectFit: "contain" }}
          />
        );
      case "AMEX":
        return (
          <AmexCardIcon
            style={{ height: "50px", width: "50px", objectFit: "contain" }}
          />
        );
      default:
        return <></>;
    }
  };

  const getPayButtonText = () => {
    if (paymentUrl) return `Continue your payment`;
    return `Pay ${currency} ${commarize(amount + fee)}`;
  };

  const [selectedCardId, setSelectedCardId] = useState<number | null>(null);

  const CollectCardDetails = (
    <>
      {/* Sandbox banner — only rendered in sandbox env */}
      {isSandbox && (
        <div className={styles.sandboxWrapper}>
          <p className={styles.sandboxTitle}>
            Use any of the options below to test the payment flow
          </p>
          <div className={styles.sandboxOptions}>
            {(["success", "bankAuthentication", "failed"] as SandboxMode[]).map(
              (mode) => (
                <div
                  key={mode}
                  className={`${styles.sandboxOption} ${
                    sandboxMode === mode ? styles.active : ""
                  }`}
                  onClick={() => handleSandboxModeChange(mode)}
                >
                  {mode === "success" && "Success"}
                  {mode === "bankAuthentication" && "Bank Authentication"}
                  {mode === "failed" && "Failed"}
                </div>
              ),
            )}
          </div>
        </div>
      )}

      <div className={styles.businessForm}>
        <form onSubmit={(e) => e.preventDefault()} className={styles.formWidth}>
          {!useSavedCards && (
            <>
              <div>
                <label
                  htmlFor="cardNumber"
                  style={{
                    color: "black",
                    margin: "0 0 4px",
                    fontSize: "14px",
                    fontWeight: "500",
                    display: "block",
                  }}
                >
                  Card Number
                </label>
                <div className={styles.cardNumberWrapper}>
                  <PrimaryTextInput
                    handleChange={updateProps}
                    inputName="CardNumber"
                    inputLabel="Card Number"
                    notRequired={false}
                    inputValue={handleCardDisplay(inputs.CardNumber)}
                    autoComplete="cc-number"
                    readOnly={isSandbox}
                    style={{
                      width: "100%",
                      ...(isSandbox && {
                        backgroundColor: "#f5f5f5",
                        cursor: "default",
                      }),
                    }}
                  />
                  <span className={styles.cardBrandLogo}>
                    {getCardTypeImage(inputs.CardNumber)}
                  </span>
                </div>
              </div>

              {creditCardType(inputs.CardNumber) == "VERVE" && (
                <div>
                  <label
                    htmlFor="cardPin"
                    style={{
                      color: "#8E173E",
                      margin: "0 0 4px",
                      fontSize: "14px",
                      fontWeight: "500",
                      display: "block",
                    }}
                  >
                    Card Pin
                  </label>
                  <div className={styles.cardNumberWrapper}>
                    <PrimaryTextInput
                      handleChange={updateProps}
                      inputName="pin"
                      inputType="password"
                      inputLabel="Card Pin"
                      inputValue={inputs.pin}
                      readOnly={isSandbox}
                      style={{
                        width: "100%",
                        ...(isSandbox && {
                          backgroundColor: "#f5f5f5",
                          cursor: "default",
                        }),
                      }}
                    />
                  </div>
                </div>
              )}

              <div className={styles.cardDetails}>
                <div>
                  <label
                    htmlFor="expiryDate"
                    style={{
                      color: "black",
                      margin: "0 0 4px",
                      fontSize: "14px",
                      fontWeight: "500",
                      display: "block",
                    }}
                  >
                    Expiry Date
                  </label>
                  <PrimaryTextInput
                    handleChange={updateProps}
                    inputName="expiryDate"
                    inputLabel="MM/YY"
                    inputValue={inputs.expiryDate}
                    autoComplete="cc-exp"
                    notRequired={false}
                    readOnly={isSandbox}
                    style={{
                      width: "100%",
                      ...(isSandbox && {
                        backgroundColor: "#f5f5f5",
                        cursor: "default",
                      }),
                    }}
                  />
                </div>
                <div style={{ position: "relative" }}>
                  <label
                    htmlFor="Cvv"
                    style={{
                      color: "black",
                      margin: "0 0 4px",
                      fontSize: "14px",
                      fontWeight: "500",
                      display: "block",
                    }}
                  >
                    CVV
                  </label>
                  <PrimaryTextInput
                    id="cvv"
                    handleChange={updateProps}
                    inputName="Cvv"
                    inputLabel="CVV"
                    inputType={showCvv ? "text" : "password"}
                    autoComplete="cc-csc"
                    inputValue={inputs.Cvv}
                    readOnly={isSandbox}
                    style={{
                      width: "100%",
                      ...(isSandbox && {
                        backgroundColor: "#f5f5f5",
                        cursor: "default",
                      }),
                    }}
                  />
                </div>
              </div>

              <div className={styles.rememberCard}>
                <input
                  type="checkbox"
                  name="saveCard"
                  onInput={updateProps}
                  disabled={isSandbox}
                />
                <span>
                  Save my card information for a faster checkout next time
                </span>
              </div>

              <Button
                value={getPayButtonText()}
                disabled={disabledFunction()}
                onClick={handleSubmit}
                type="button"
                className={
                  disabledFunction() ? styles.button : styles.buttonActive
                }
              />
            </>
          )}

          {useSavedCards && (
            <div className={styles.PayWithSavedCardWrapper}>
              {saveCards.length > 0 ? (
                saveCards.map((x) => (
                  <div
                    key={x.savedCardId}
                    className={`${styles.PayWithSavedCardItem} ${
                      selectedCardId === x.savedCardId
                        ? styles.activeSelection
                        : ""
                    }`}
                    onClick={() => {
                      setSelectedCardId(x.savedCardId);
                      SubmitSavedCard(x.savedCardId);
                    }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "15px",
                      cursor: "pointer",
                      border: "1px solid #AAAAAA",
                      borderRadius: "8px",
                      transition: "background-color 0.3s, border-color 0.3s",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div className={styles.icon}>
                        {getCardTypeImage("", x.cardType)}
                      </div>
                      <div className={styles.radioLabel}>
                        <p>{x.cardType}</p>
                        <p
                          style={{
                            color: "black",
                            fontSize: "18px",
                            fontWeight: "700",
                          }}
                        >
                          {x.cardFirstSixDigits}xxxxxxxx{x.cardLastFourDigits}
                        </p>
                      </div>
                    </div>
                    <input
                      type="radio"
                      id={`savedCard-${x.savedCardId}`}
                      name="savedCard"
                      value={x.savedCardId}
                      checked={selectedCardId === x.savedCardId}
                      onChange={() => setSelectedCardId(x.savedCardId)}
                      className={styles.customRadio}
                    />
                  </div>
                ))
              ) : (
                <p className={styles.noSavedCardsText}>No saved cards</p>
              )}
            </div>
          )}
        </form>

        <div className={styles.poweredByBox}>
          <p className={styles.poweredBy}>Powered by</p>
          <img
            src={transactpay}
            style={{ width: "auto", height: "20px", objectFit: "cover" }}
            alt="Transactpay"
          />
        </div>
      </div>
    </>
  );

  const ConfirmRedirect = (
    <div className={styles.confirmRedirect}>
      <p>
        You will be redirected to your card issuer's verification page to
        complete this transaction
      </p>
      <Button
        type="button"
        value={getPayButtonText()}
        onClick={handleSubmit}
        className={styles.confirmRedirectButton}
      />
    </div>
  );

  const ProvisionOtpForm = (
    <div className={styles.provisionOtpInput}>
      <p>{otpInputs.message}</p>
      <form onSubmit={(e) => e.preventDefault()} className={styles.formWidth}>
        <div className={styles.otpInputContainer}>
          {Array(6)
            .fill("")
            .map((_, index) => (
              <input
                key={index}
                type="text"
                inputMode="numeric"
                autoComplete={index === 0 ? "one-time-code" : "off"}
                pattern="[0-9]*"
                maxLength={6}
                className={`${styles.otpInput} cardOtpInput`}
                value={cardOtp[index] || ""}
                onChange={(e) => handleCardOtpChange(e, index)}
                onKeyDown={(e) => handleCardOtpKeyDown(e, index)}
              />
            ))}
        </div>
        <div className={styles.provisionOtpInputButton}>
          <Button
            value="Authorize Payment"
            disabled={cardOtp.length < 6}
            onClick={(e: any) => {
              e.preventDefault();
              if (cardOtp.length < 6) return;
              handleOtpSubmit(); // routes to sandbox or real handler automatically
            }}
            className={cardOtp.length < 6 ? styles.button : styles.buttonActive}
          />
        </div>
      </form>
    </div>
  );

  const ConfirmingPayment = (
    <div className={styles.confirmRedirect}>
      <p>Checking transaction status... Please wait</p>
    </div>
  );

  const GetActiveSection = () => {
    switch (activeSection) {
      case "successful":
        return <SuccessfulPaymentCard paymentmethod="card" />;
      case "confirm-redirect":
        return ConfirmRedirect;
      case "validate-otp":
        return ProvisionOtpForm;
      case "confirm-payment":
        return ConfirmingPayment;
      case "confirm-payment-pending":
        return <PendingPaymentCard paymentmethod="card" />;
      case "collect-card-details":
      default:
        return CollectCardDetails;
    }
  };

  return GetActiveSection();
};

export default DebitCard;
